/* import libraries */
import { useState, useEffect } from "react";

/* import components */
import Card from "react-bootstrap/Card";

const BadgeOutline = (props) => {
    const [color, setColor] = useState("black");

    useEffect(() => {
        switch (props.title) {
            case "RydePOOL":
                setColor("#42B625");
                break;
            case "RydeFLASH":
                setColor("#E93864");
                break;
            case "RydeX": case "RydeXL":
                setColor("#0076FF");
                break;
            case "RydePET": case "RydePET XL":
                setColor("#AD7954");
                break;
            case "RydeHIRE":
                setColor("#00AE9D");
                break;
            case "RydeTAXI":
                setColor("#F4A44A");
                break;
            case "RydeSEND":
                setColor("#F4A248");
                break;
            case "RydeX GO":
                setColor("#7D0D3B");
                break;
            default:
                setColor("black");
                break;
        }
    }, [props.title]);

    return (
        <>
            <Card className="rydetype-card topics font-semibold"
                style={{ borderColor: color, color: color}}>
                {props.title}
            </Card>
        </>
    );
}

export default BadgeOutline;